import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter  } from "react-router-dom";
import SectionLoading from '../../common/SectionLoading';
import MiniSpinner from '../../common/MiniSpinner';
import SectionLoadingError from '../../common/SectionLoadingError';
import * as types from '../../../constants/actionTypes';
import { rxRoute } from "../../../helpers/formatting";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

class PrescriptionStatus extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PrescriptionStatus.ComponentDidMount", new Date(), Tools.getURLPath());
        this.orderRefill = this.orderRefill.bind(this);
    }

    orderRefill(ctaText) {
        const { rx } = this.props;
        //const request = {
        //    SubmitOrderItems: [{
        //        StoreNumber: rx.StoreNumber,
        //        RxDetails: [{
        //            RxNumber: rx.RxNumber,
        //            NextFill: ctaText
        //        }]
        //    }]
        //};
        //this.props.orderRefill(request);
        if (rx.StoreNumber && rx.RxNumber) {
            logUI("MBHWeb.UI.Rx.PrescriptionStatus.OrderRefill", new Date(), Tools.getURLPath());
            this.props.history.push(
                '/pharmacyRxRefill/' + rx.StoreNumber + '/' + rx.RxNumber
            );
        } else {
            logUI("MBHWeb.UI.Rx.PrescriptionStatus.OrderRefill.Failure", new Date(), Tools.getURLPath());
        }
    }

    render() {
        const { containerClass, rx, waitingOnRefillOrder, refillOrderResult, refillOrderError, technicalHelpDeskNumber  } = this.props;
        const OUT_OF_REFILLS = 'Out of Refills';

        const isPharmacyPermanentlyClosed = rx && rx.Pharmacy && ((typeof rx.Pharmacy.IsPharmacyActive !== 'undefined' && rx.Pharmacy.IsPharmacyActive === false) || (rx.Pharmacy.OperationHours && rx.Pharmacy.OperationHours.Display && rx.Pharmacy.OperationHours.Display.HoursOfOperationToday && rx.Pharmacy.OperationHours.Display.HoursOfOperationToday.toUpperCase() === "PERMANENTLY CLOSED")) ? true : false;

        if (!rx) {
            return null;
        }

        let status = rx.IsArchived ? 'Archived' : rx.Status;
        if (!rx.Status) {
            status = 'Unknown Status';
            rx.Status = status;
        }

        let ctaText = 'Ready for refill';
        let ctaLink = null;
        let statusClass = '';
        let errorMessage = '';

        const storeNumberMatchesWithResult = refillOrderResult && refillOrderResult.StoreNumber === rx.StoreNumber;
        const rxNumberMatchesWithResult = storeNumberMatchesWithResult && refillOrderResult.RenewedRx && refillOrderResult.RenewedRx.Prescriptions[0].RxNumber === rx.RxNumber;

        if (isPharmacyPermanentlyClosed) {
            status = 'Transfer Required';
        }

        switch (status) {
            case 'Ready for Pickup':
                statusClass = 'status-ready-pickup';
                ctaLink = `${rxRoute('pickupDetails')}/${rx.Pharmacy.StoreNumber}`;
                ctaText = 'SEE ORDER DETAILS';
                break;
            case 'Ready for Refill':
                statusClass = 'status-ready-refill';
                ctaLink = `${rxRoute('rxRefill')}/${rx.Pharmacy.StoreNumber}/${rx.RxNumber}`;
                ctaText = 'ORDER A REFILL';
                break;
            case OUT_OF_REFILLS:
                if (rxNumberMatchesWithResult) {
                    statusClass = 'status-refill-in-progress';
                    status = 'Refills renewal in progress';
                }
                else {
                    statusClass = 'status-out-of-refills';
                    //ctaLink = `${rxRoute('rxRefill')}/${rx.Pharmacy.StoreNumber}/${rx.RxNumber}`;
                    ctaText = 'RENEW REFILLS';
                }
                break;
            case 'Too Soon To Refill': statusClass = 'status-too-soon'; break;
            case 'Refill in Progress': statusClass = 'status-refill-in-progress'; break;
            case 'Transfer in Progress': statusClass = 'status-transfer'; break;
            case 'Pending Issue':
                statusClass = 'status-pending-issue';
                errorMessage = 'There was an error with the transfer. Please contact your BSW Pharmacy to complete the transfer.';
                break;
            case 'Transfer Required':
                statusClass = 'status-pharmacy-closed';
                status = 'TRANSFER REQUIRED';
                ctaLink = `${rxRoute('bswTransfer')}`;
                errorMessage = 'The pickup location has permanently closed. Transfer this prescription to another location to refill it.';
                ctaText = 'TRANSFER PRESCRIPTION';
                break;
            case 'Archived': statusClass = 'status-archived'; break;
            default: statusClass = 'status-ready-refill';
        }

        let statusLabelClass = 'col-md-7';
        let statusMsgClass = '';
        let statusBtnClass = 'col-md-5';

        if (errorMessage) {
            if (isPharmacyPermanentlyClosed) {
                statusLabelClass = 'col-xl-3';
                statusMsgClass = 'col-xl-6';
                statusBtnClass = 'col-xl-3';
            } else {
                statusLabelClass = 'col-md-4';
                statusMsgClass = 'col-md-8';
            }
        }

        return (
            <div className="col-12">
                {waitingOnRefillOrder &&
                    <div className="overlay-loading-container row">
                        <div className="col-12 align-self-center">
                            <MiniSpinner />
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12">
                        <div className={"rx-detail-status " + containerClass + ' ' + statusClass}>
                            {
                                <div className={"row" + (errorMessage ? '' : ' align-items-center')}>
                                    <div className={"col-12 rx-detail-status__name " + statusLabelClass}>{status}</div>
                                    {errorMessage &&
                                        <div className={"col-12 status-error-msg " + statusMsgClass}>
                                        {errorMessage}                                        
                                        </div>
                                    }
                                    <div className={"col-12 btn-container " + statusBtnClass}>
                                        {status === OUT_OF_REFILLS && !rxNumberMatchesWithResult
                                            ? <button className="btn btn-primary" disabled={rx.archiving || waitingOnRefillOrder || rxNumberMatchesWithResult}
                                                onClick={() => this.orderRefill(ctaText)}
                                              >
                                                {ctaText}
                                              </button>
                                            : ctaLink && <Link to={ctaLink} className="btn btn-primary" disabled={rx.archiving}>{ctaText}</Link>
                                        }
                                     </div>
                                </div>
                            }
                        </div>
                    </div>
                    {!waitingOnRefillOrder &&
                        <div className="col-12 rx-detail-status__confirmation">

                            {storeNumberMatchesWithResult &&
                                <React.Fragment>
                                    {rxNumberMatchesWithResult &&
                                        <div className="status-renew-success">
                                            <div className="row align-items-center">
                                                <div className="col-12">
                                                    {refillOrderResult.RenewedRx.Message}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {refillOrderResult.FailuresRx && refillOrderResult.FailuresRx.Prescriptions[0].RxNumber === rx.RxNumber &&
                                        <SectionLoadingError message={refillOrderResult.FailuresRx.Message} />
                                    }
                                </React.Fragment>
                            }
                            {refillOrderError &&
                                <SectionLoadingError message="Sorry, we're not able to make your request. Please try again later." />
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        refillOrderResult: state.pharmacy.submitOrderResult,
        waitingOnRefillOrder: state.pharmacy.isSubmitIvrOrderRequest,
        refillOrderError: state.pharmacy.OrderRefillErrorStatus,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : ""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        orderRefill: (RxOrderRefillData) => dispatch({ type: types.SUBMIT_IVR_ORDER_REQUEST, payload: { RxOrderRefillData } })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrescriptionStatus));